export default {
  "content": "<rect width=\"4\" height=\"5\" y=\"9\" fill=\"#FFC117\" rx=\"1\"/><rect width=\"4\" height=\"10\" x=\"5\" y=\"4\" fill=\"#FFC117\" rx=\"1\"/><rect width=\"4\" height=\"14\" x=\"10\" fill=\"#fff\" fill-opacity=\".37\" rx=\"1\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "14",
    "fill": "none",
    "viewBox": "0 0 14 14"
  }
};